import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=205fcd70&scoped=true"
import script from "./Voucher.vue?vue&type=script&lang=js"
export * from "./Voucher.vue?vue&type=script&lang=js"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=205fcd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fcd70",
  null
  
)

export default component.exports